import { render } from "./face_1.svg?vue&type=template&id=3a41c605"
const script = {}
script.render = render

export default script